<template>
  <div class="body-div">
    <span class="filter-buttons">
      <div class="report-wrapper">
        <date-picker
          lang="en"
          placeholder="Select Date"
          :not-after="new Date()"
          v-model="reportDate"
          input-class="form-control"
        ></date-picker>
        <button
          :disabled="reportDate === null"
          :class="{ disabled: reportDate === null }"
          class="bttn"
          @click="getReportByDate"
        >
          Get Report
        </button>
      </div>
      <div class="filter-group">
        <div>
          <input
            @click="changeFilter($event)"
            type="radio"
            name="filters"
            id="all"
            value="ALL"
            checked
          />
          <label for="all">ALL</label>
        </div>
        <div>
          <input
            @click="changeFilter($event)"
            type="radio"
            name="filters"
            id="reg"
            value="REG"
          />
          <label for="reg">REG</label>
        </div>
        <div>
          <input
            @click="changeFilter($event)"
            type="radio"
            name="filters"
            id="dup"
            value="DUP"
          />
          <label for="dup">DUP</label>
        </div>
      </div>
    </span>
    <div class="top-div">
      <div class="table">
        <table
          v-if="
            Object.keys(report).length > 0 &&
              report['assigned_agents']['all_data'][filterOption] &&
              report['assigned_agents']['all_data'][filterOption].length > 0 &&
              salesPersonList.find(
                item =>
                  item.id ===
                  report['assigned_agents']['all_data'][filterOption][0].id
              )
          "
        >
          <thead>
            Yesterday Registered and assigned Agents |
            {{
              report["assigned_agents"]["all_data"][filterOption][0]
                .total_in_time_frame
            }}
          </thead>
          <tbody>
            <tr>
              <td>
                {{
                  salesPersonList.find(
                    item =>
                      item.id ===
                      report["assigned_agents"]["all_data"][filterOption][0].id
                  ).full_name
                }}
                |
                {{
                  report["assigned_agents"]["all_data"][filterOption][0].total
                }}
                |
                {{
                  report["assigned_agents"]["all_data"][filterOption][0]
                    .total_in_time_frame
                }}
                |
                {{
                  (
                    (100 *
                      report["assigned_agents"]["all_data"][filterOption][0]
                        .total) /
                    report["assigned_agents"]["all_data"][filterOption][0]
                      .total_in_time_frame
                  ).toFixed(2)
                }}%
                <br />
                <span
                  class="report-rank"
                  v-for="rank in report['assigned_agents']['all_data'][
                    filterOption
                  ][0].rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
            <hr />
            <tr>
              <td
                v-for="cond in report['assigned_agents']['all_data'][
                  filterOption
                ][0].campaign_aaid"
                :key="cond.id"
              >
                <span
                  >{{ cond.id }} | {{ cond.amount }} |
                  {{
                    report["assigned_agents"]["all_data"][filterOption][0]
                      .total_in_time_frame
                  }}
                  |
                  {{
                    (
                      (100 * cond.amount) /
                      report["assigned_agents"]["all_data"][filterOption][0]
                        .total_in_time_frame
                    ).toFixed(2)
                  }}% |
                  {{
                    (
                      (100 * cond.amount) /
                      report["assigned_agents"]["all_data"][filterOption][0]
                        .total
                    ).toFixed(2)
                  }}%</span
                >
                <br />
                <span
                  class="report-rank"
                  v-for="rank in cond.rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
            <tr>
              <td
                v-for="cond in report['assigned_agents']['all_data'][
                  filterOption
                ][0].country_id"
                :key="cond.id"
              >
                <span
                  >{{
                    dictionaries.general.countries.find(
                      country => country.id === cond.id
                    ).name
                  }}
                  | {{ cond.amount }} |
                  {{
                    report["assigned_agents"]["all_data"][filterOption][0]
                      .total_in_time_frame
                  }}
                  |
                  {{
                    (
                      (100 * cond.amount) /
                      report["assigned_agents"]["all_data"][filterOption][0]
                        .total_in_time_frame
                    ).toFixed(2)
                  }}% |
                  {{
                    (
                      (100 * cond.amount) /
                      report["assigned_agents"]["all_data"][filterOption][0]
                        .total
                    ).toFixed(2)
                  }}%</span
                >
                <br />
                <span
                  class="report-rank"
                  v-for="rank in cond.rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
            <tr>
              <td
                v-for="cond in report['assigned_agents']['all_data'][
                  filterOption
                ][0].keyword"
                :key="cond.id"
              >
                <span
                  >{{ cond.id }} | {{ cond.amount }} |
                  {{
                    report["assigned_agents"]["all_data"][filterOption][0]
                      .total_in_time_frame
                  }}
                  |
                  {{
                    (
                      (100 * cond.amount) /
                      report["assigned_agents"]["all_data"][filterOption][0]
                        .total_in_time_frame
                    ).toFixed(2)
                  }}% |
                  {{
                    (
                      (100 * cond.amount) /
                      report["assigned_agents"]["all_data"][filterOption][0]
                        .total
                    ).toFixed(2)
                  }}%</span
                >
                <br />
                <span
                  class="report-rank"
                  v-for="rank in cond.rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
        <table
          v-if="
            Object.keys(report).length > 0 &&
              report['bad_number_reasons']['all_data'][filterOption] &&
              report['bad_number_reasons']['all_data'][filterOption].length >
                0 &&
              dictionaries.activity.bad_number_states.find(
                item =>
                  item.id ===
                  report['bad_number_reasons']['all_data'][filterOption][0].id
              )
          "
        >
          <thead>
            Bad Number - Reasons |
            {{
              report["bad_number_reasons"]["all_data"][filterOption][0]
                .total_in_time_frame
            }}
          </thead>
          <tbody>
            <tr>
              <td>
                {{
                  dictionaries.activity.bad_number_states.find(
                    item =>
                      item.id ===
                      report["bad_number_reasons"]["all_data"][filterOption][0]
                        .id
                  ).name
                }}
                |
                {{
                  report["bad_number_reasons"]["all_data"][filterOption][0]
                    .total
                }}
                |
                {{
                  report["bad_number_reasons"]["all_data"][filterOption][0]
                    .total_in_time_frame
                }}
                |
                {{
                  (
                    (100 *
                      report["bad_number_reasons"]["all_data"][filterOption][0]
                        .total) /
                    report["bad_number_reasons"]["all_data"][filterOption][0]
                      .total_in_time_frame
                  ).toFixed(2)
                }}%
                <br />
                <span
                  class="report-rank"
                  v-for="rank in report['bad_number_reasons']['all_data'][
                    filterOption
                  ][0].rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
            <hr />
            <tr>
              <td
                v-for="cond in report['bad_number_reasons']['all_data'][
                  filterOption
                ][0].users"
                :key="cond.id"
              >
                {{
                  salesPersonList.find(item => item.id === cond.id).full_name
                }}
                | {{ cond.amount }} |
                {{
                  report["bad_number_reasons"]["all_data"][filterOption][0]
                    .total_in_time_frame
                }}
                |
                {{
                  (
                    (100 * cond.amount) /
                    report["bad_number_reasons"]["all_data"][filterOption][0]
                      .total_in_time_frame
                  ).toFixed(2)
                }}% |
                {{
                  (
                    (100 * cond.amount) /
                    report["bad_number_reasons"]["all_data"][filterOption][0]
                      .total
                  ).toFixed(2)
                }}%
                <br />
                <span
                  class="report-rank"
                  v-for="rank in cond.rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
            <tr>
              <td
                v-for="cond in report['bad_number_reasons']['all_data'][
                  filterOption
                ][0].campaign_aaid"
                :key="cond.id"
              >
                <span
                  >{{ cond.id }} | {{ cond.amount }} |
                  {{
                    report["bad_number_reasons"]["all_data"][filterOption][0]
                      .total_in_time_frame
                  }}
                  |
                  {{
                    (
                      (100 * cond.amount) /
                      report["bad_number_reasons"]["all_data"][filterOption][0]
                        .total_in_time_frame
                    ).toFixed(2)
                  }}% |
                  {{
                    (
                      (100 * cond.amount) /
                      report["bad_number_reasons"]["all_data"][filterOption][0]
                        .total
                    ).toFixed(2)
                  }}%</span
                >
                <br />
                <span
                  class="report-rank"
                  v-for="rank in cond.rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
            <tr>
              <td
                v-for="cond in report['bad_number_reasons']['all_data'][
                  filterOption
                ][0].country_id"
                :key="cond.id"
              >
                <span
                  >{{
                    dictionaries.general.countries.find(
                      country => country.id === cond.id
                    ).name
                  }}
                  | {{ cond.amount }} |
                  {{
                    report["bad_number_reasons"]["all_data"][filterOption][0]
                      .total_in_time_frame
                  }}
                  |
                  {{
                    (
                      (100 * cond.amount) /
                      report["bad_number_reasons"]["all_data"][filterOption][0]
                        .total_in_time_frame
                    ).toFixed(2)
                  }}% |
                  {{
                    (
                      (100 * cond.amount) /
                      report["bad_number_reasons"]["all_data"][filterOption][0]
                        .total
                    ).toFixed(2)
                  }}%</span
                >
                <br />
                <span
                  class="report-rank"
                  v-for="rank in cond.rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
            <tr>
              <td
                v-for="cond in report['bad_number_reasons']['all_data'][
                  filterOption
                ][0].keyword"
                :key="cond.id"
              >
                <span
                  >{{ cond.id }} | {{ cond.amount }} |
                  {{
                    report["bad_number_reasons"]["all_data"][filterOption][0]
                      .total_in_time_frame
                  }}
                  |
                  {{
                    (
                      (100 * cond.amount) /
                      report["bad_number_reasons"]["all_data"][filterOption][0]
                        .total_in_time_frame
                    ).toFixed(2)
                  }}% |
                  {{
                    (
                      (100 * cond.amount) /
                      report["bad_number_reasons"]["all_data"][filterOption][0]
                        .total
                    ).toFixed(2)
                  }}%</span
                >
                <br />
                <span
                  class="report-rank"
                  v-for="rank in cond.rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
        <table
          v-if="
            Object.keys(report).length > 0 &&
              report['brokers']['all_data'][filterOption] &&
              report['brokers']['all_data'][filterOption].length > 0 &&
              dictionaries.general.brokers.find(
                item =>
                  item.id === report['brokers']['all_data'][filterOption][0].id
              )
          "
        >
          <thead>
            Brokers |
            {{
              report["brokers"]["all_data"][filterOption][0].total_in_time_frame
            }}
          </thead>
          <tbody>
            <tr>
              <td>
                {{
                  dictionaries.general.brokers.find(
                    item =>
                      item.id ===
                      report["brokers"]["all_data"][filterOption][0].id
                  ).name
                }}
                | {{ report["brokers"]["all_data"][filterOption][0].total }} |
                {{
                  report["brokers"]["all_data"][filterOption][0]
                    .total_in_time_frame
                }}
                |
                {{
                  (
                    (100 *
                      report["brokers"]["all_data"][filterOption][0].total) /
                    report["brokers"]["all_data"][filterOption][0]
                      .total_in_time_frame
                  ).toFixed(2)
                }}%
                <br />
                <span
                  class="report-rank"
                  v-for="rank in report['brokers']['all_data'][filterOption][0]
                    .rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
            <hr />
            <tr>
              <td
                v-for="cond in report['brokers']['all_data'][filterOption][0]
                  .users"
                :key="cond.id"
              >
                {{
                  salesPersonList.find(item => item.id === cond.id).full_name
                }}
                | {{ cond.amount }} |
                {{
                  report["brokers"]["all_data"][filterOption][0]
                    .total_in_time_frame
                }}
                |
                {{
                  (
                    (100 * cond.amount) /
                    report["brokers"]["all_data"][filterOption][0]
                      .total_in_time_frame
                  ).toFixed(2)
                }}% |
                {{
                  (
                    (100 * cond.amount) /
                    report["brokers"]["all_data"][filterOption][0].total
                  ).toFixed(2)
                }}%
                <br />
                <span
                  class="report-rank"
                  v-for="rank in cond.rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
            <tr>
              <td
                v-for="cond in report['brokers']['all_data'][filterOption][0]
                  .campaign_aaid"
                :key="cond.id"
              >
                <span
                  >{{ cond.id }} | {{ cond.amount }} |
                  {{
                    report["brokers"]["all_data"][filterOption][0]
                      .total_in_time_frame
                  }}
                  |
                  {{
                    (
                      (100 * cond.amount) /
                      report["brokers"]["all_data"][filterOption][0]
                        .total_in_time_frame
                    ).toFixed(2)
                  }}% |
                  {{
                    (
                      (100 * cond.amount) /
                      report["brokers"]["all_data"][filterOption][0].total
                    ).toFixed(2)
                  }}%</span
                >
                <br />
                <span
                  class="report-rank"
                  v-for="rank in cond.rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
            <tr>
              <td
                v-for="cond in report['brokers']['all_data'][filterOption][0]
                  .keyword"
                :key="cond.id"
              >
                <span
                  >{{ cond.id }} | {{ cond.amount }} |
                  {{
                    report["brokers"]["all_data"][filterOption][0]
                      .total_in_time_frame
                  }}
                  |
                  {{
                    (
                      (100 * cond.amount) /
                      report["brokers"]["all_data"][filterOption][0]
                        .total_in_time_frame
                    ).toFixed(2)
                  }}% |
                  {{
                    (
                      (100 * cond.amount) /
                      report["brokers"]["all_data"][filterOption][0].total
                    ).toFixed(2)
                  }}%</span
                >
                <br />
                <span
                  class="report-rank"
                  v-for="rank in cond.rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
            <tr>
              <td
                v-for="cond in report['brokers']['all_data'][filterOption][0]
                  .country_id"
                :key="cond.id"
              >
                <span
                  >{{
                    dictionaries.general.countries.find(
                      country => country.id === cond.id
                    ).name
                  }}
                  | {{ cond.amount }} |
                  {{
                    report["brokers"]["all_data"][filterOption][0]
                      .total_in_time_frame
                  }}
                  |
                  {{
                    (
                      (100 * cond.amount) /
                      report["brokers"]["all_data"][filterOption][0]
                        .total_in_time_frame
                    ).toFixed(2)
                  }}% |
                  {{
                    (
                      (100 * cond.amount) /
                      report["brokers"]["all_data"][filterOption][0].total
                    ).toFixed(2)
                  }}%</span
                >
                <br />
                <span
                  class="report-rank"
                  v-for="rank in cond.rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
        <table
          v-if="
            Object.keys(report).length > 0 &&
              report['campaigns']['all_data'][filterOption] &&
              report['campaigns']['all_data'][filterOption].length > 0
          "
        >
          <thead>
            Campaigns |
            {{
              report["campaigns"]["all_data"][filterOption][0]
                .total_in_time_frame
            }}
          </thead>
          <tbody>
            <tr>
              <td>
                {{ report["campaigns"]["all_data"][filterOption][0].id }} |
                {{ report["campaigns"]["all_data"][filterOption][0].total }} |
                {{
                  report["campaigns"]["all_data"][filterOption][0]
                    .total_in_time_frame
                }}
                |
                {{
                  (
                    (100 *
                      report["campaigns"]["all_data"][filterOption][0].total) /
                    report["campaigns"]["all_data"][filterOption][0]
                      .total_in_time_frame
                  ).toFixed(2)
                }}%
                <br />
                <span
                  class="report-rank"
                  v-for="rank in report['campaigns']['all_data'][
                    filterOption
                  ][0].rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
            <hr />
            <tr>
              <td
                v-for="cond in report['campaigns']['all_data'][filterOption][0]
                  .users"
                :key="cond.id"
              >
                {{
                  salesPersonList.find(item => item.id === cond.id).full_name
                }}
                | {{ cond.amount }} |
                {{
                  report["campaigns"]["all_data"][filterOption][0]
                    .total_in_time_frame
                }}
                |
                {{
                  (
                    (100 * cond.amount) /
                    report["campaigns"]["all_data"][filterOption][0]
                      .total_in_time_frame
                  ).toFixed(2)
                }}% |
                {{
                  (
                    (100 * cond.amount) /
                    report["campaigns"]["all_data"][filterOption][0].total
                  ).toFixed(2)
                }}%
                <br />
                <span
                  class="report-rank"
                  v-for="rank in cond.rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
            <tr>
              <td
                v-for="cond in report['campaigns']['all_data'][filterOption][0]
                  .keyword"
                :key="cond.id"
              >
                <span
                  >{{ cond.id }} | {{ cond.amount }} |
                  {{
                    report["campaigns"]["all_data"][filterOption][0]
                      .total_in_time_frame
                  }}
                  |
                  {{
                    (
                      (100 * cond.amount) /
                      report["campaigns"]["all_data"][filterOption][0]
                        .total_in_time_frame
                    ).toFixed(2)
                  }}% |
                  {{
                    (
                      (100 * cond.amount) /
                      report["campaigns"]["all_data"][filterOption][0].total
                    ).toFixed(2)
                  }}%</span
                >
                <br />
                <span
                  class="report-rank"
                  v-for="rank in cond.rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
            <tr>
              <td
                v-for="cond in report['campaigns']['all_data'][filterOption][0]
                  .country_id"
                :key="cond.id"
              >
                <span
                  >{{
                    dictionaries.general.countries.find(
                      country => country.id === cond.id
                    ).name
                  }}
                  | {{ cond.amount }} |
                  {{
                    report["campaigns"]["all_data"][filterOption][0]
                      .total_in_time_frame
                  }}
                  |
                  {{
                    (
                      (100 * cond.amount) /
                      report["campaigns"]["all_data"][filterOption][0]
                        .total_in_time_frame
                    ).toFixed(2)
                  }}% |
                  {{
                    (
                      (100 * cond.amount) /
                      report["campaigns"]["all_data"][filterOption][0].total
                    ).toFixed(2)
                  }}%</span
                >
                <br />
                <span
                  class="report-rank"
                  v-for="rank in cond.rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
        <table
          v-if="
            Object.keys(report).length > 0 &&
              !Array.isArray(report['deposits']['all_data'][filterOption]) &&
              report['deposits']['all_data'][filterOption]
          "
        >
          <thead>
            Deposits |
            {{
              report["deposits"]["all_data"][filterOption].total_in_time_frame
            }}
          </thead>
          <tbody>
            <tr>
              <td
                v-if="
                  Object.keys(
                    report['deposits']['all_data'][filterOption].campaign_aaid
                  ).length > 0
                "
              >
                <span
                  >{{
                    report["deposits"]["all_data"][filterOption]
                      .campaign_aaid[0].id
                  }}
                  |
                  {{
                    report["deposits"]["all_data"][filterOption]
                      .campaign_aaid[0].amount
                  }}
                  |
                  {{
                    report["deposits"]["all_data"][filterOption]
                      .total_in_time_frame
                  }}
                  |
                  {{
                    (
                      (100 *
                        report["deposits"]["all_data"][filterOption]
                          .campaign_aaid[0].amount) /
                      report["deposits"]["all_data"][filterOption]
                        .total_in_time_frame
                    ).toFixed(2)
                  }}%</span
                >
                <br />
                <span
                  class="report-rank"
                  v-for="rank in report['deposits']['all_data'][filterOption]
                    .campaign_aaid[0].rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
            <tr>
              <td
                v-if="
                  Object.keys(
                    report['deposits']['all_data'][filterOption].users
                  ).length > 0
                "
              >
                <span>
                  {{
                    salesPersonList.find(
                      item =>
                        item.id ===
                        report["deposits"]["all_data"][filterOption].users[0].id
                    ).full_name
                  }}
                  |
                  {{
                    report["deposits"]["all_data"][filterOption].users[0].amount
                  }}
                  |
                  {{
                    report["deposits"]["all_data"][filterOption]
                      .total_in_time_frame
                  }}
                  |
                  {{
                    (
                      (100 *
                        report["deposits"]["all_data"][filterOption].users[0]
                          .amount) /
                      report["deposits"]["all_data"][filterOption]
                        .total_in_time_frame
                    ).toFixed(2)
                  }}%
                </span>
                <br />
                <span
                  class="report-rank"
                  v-for="rank in report['deposits']['all_data'][filterOption]
                    .users[0].rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
            <tr>
              <td
                v-if="
                  Object.keys(
                    report['deposits']['all_data'][filterOption].country_id
                  ).length > 0
                "
              >
                <span
                  >{{
                    dictionaries.general.countries.find(
                      country =>
                        country.id ===
                        report["deposits"]["all_data"][filterOption]
                          .country_id[0].id
                    ).name
                  }}
                  |
                  {{
                    report["deposits"]["all_data"][filterOption].country_id[0]
                      .amount
                  }}
                  |
                  {{
                    report["deposits"]["all_data"][filterOption]
                      .total_in_time_frame
                  }}
                  |
                  {{
                    (
                      (100 *
                        report["deposits"]["all_data"][filterOption]
                          .country_id[0].amount) /
                      report["deposits"]["all_data"][filterOption]
                        .total_in_time_frame
                    ).toFixed(2)
                  }}%</span
                >
                <br />
                <span
                  class="report-rank"
                  v-for="rank in report['deposits']['all_data'][filterOption]
                    .country_id[0].rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
            <tr>
              <td
                v-if="
                  Object.keys(
                    report['deposits']['all_data'][filterOption].keyword
                  ).length > 0
                "
              >
                <span
                  >{{
                    report["deposits"]["all_data"][filterOption].keyword[0].id
                  }}
                  |
                  {{
                    report["deposits"]["all_data"][filterOption].keyword[0]
                      .amount
                  }}
                  |
                  {{
                    report["deposits"]["all_data"][filterOption]
                      .total_in_time_frame
                  }}
                  |
                  {{
                    (
                      (100 *
                        report["deposits"]["all_data"][filterOption].keyword[0]
                          .amount) /
                      report["deposits"]["all_data"][filterOption]
                        .total_in_time_frame
                    ).toFixed(2)
                  }}%</span
                >
                <br />
                <span
                  class="report-rank"
                  v-for="rank in report['deposits']['all_data'][filterOption]
                    .keyword[0].rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
        <table
          v-if="
            Object.keys(report).length > 0 &&
              report['keywords']['all_data'][filterOption] &&
              report['keywords']['all_data'][filterOption].length > 0
          "
        >
          <thead>
            Keywords |
            {{
              report["keywords"]["all_data"][filterOption][0]
                .total_in_time_frame
            }}
          </thead>
          <tbody>
            <tr>
              <td>
                {{ report["keywords"]["all_data"][filterOption][0].id }} |
                {{ report["keywords"]["all_data"][filterOption][0].total }} |
                {{
                  report["keywords"]["all_data"][filterOption][0]
                    .total_in_time_frame
                }}
                |
                {{
                  (
                    (100 *
                      report["keywords"]["all_data"][filterOption][0].total) /
                    report["keywords"]["all_data"][filterOption][0]
                      .total_in_time_frame
                  ).toFixed(2)
                }}%
                <br />
                <span
                  class="report-rank"
                  v-for="rank in report['keywords']['all_data'][filterOption][0]
                    .rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
            <hr />
            <tr>
              <td
                v-for="cond in report['keywords']['all_data'][filterOption][0]
                  .users"
                :key="cond.id"
              >
                {{
                  salesPersonList.find(item => item.id === cond.id).full_name
                }}
                | {{ cond.amount }} |
                {{
                  report["keywords"]["all_data"][filterOption][0]
                    .total_in_time_frame
                }}
                |
                {{
                  (
                    (100 * cond.amount) /
                    report["keywords"]["all_data"][filterOption][0]
                      .total_in_time_frame
                  ).toFixed(2)
                }}% |
                {{
                  (
                    (100 * cond.amount) /
                    report["keywords"]["all_data"][filterOption][0].total
                  ).toFixed(2)
                }}%
                <br />
                <span
                  class="report-rank"
                  v-for="rank in cond.rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
            <tr>
              <td
                v-for="cond in report['keywords']['all_data'][filterOption][0]
                  .campaign_aaid"
                :key="cond.id"
              >
                <span
                  >{{ cond.id }} | {{ cond.amount }} |
                  {{
                    report["keywords"]["all_data"][filterOption][0]
                      .total_in_time_frame
                  }}
                  |
                  {{
                    (
                      (100 * cond.amount) /
                      report["keywords"]["all_data"][filterOption][0]
                        .total_in_time_frame
                    ).toFixed(2)
                  }}% |
                  {{
                    (
                      (100 * cond.amount) /
                      report["keywords"]["all_data"][filterOption][0].total
                    ).toFixed(2)
                  }}%</span
                >
                <br />
                <span
                  class="report-rank"
                  v-for="rank in cond.rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
            <tr>
              <td
                v-for="cond in report['keywords']['all_data'][filterOption][0]
                  .country_id"
                :key="cond.id"
              >
                <span
                  >{{
                    dictionaries.general.countries.find(
                      country => country.id === cond.id
                    ).name
                  }}
                  | {{ cond.amount }} |
                  {{
                    report["keywords"]["all_data"][filterOption][0]
                      .total_in_time_frame
                  }}
                  |
                  {{
                    (
                      (100 * cond.amount) /
                      report["keywords"]["all_data"][filterOption][0]
                        .total_in_time_frame
                    ).toFixed(2)
                  }}% |
                  {{
                    (
                      (100 * cond.amount) /
                      report["keywords"]["all_data"][filterOption][0].total
                    ).toFixed(2)
                  }}%</span
                >
                <br />
                <span
                  class="report-rank"
                  v-for="rank in cond.rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
        <table
          v-if="
            Object.keys(report).length > 0 &&
              report['no_answer_agents']['all_data'][filterOption] &&
              report['no_answer_agents']['all_data'][filterOption].length > 0 &&
              salesPersonList.find(
                item =>
                  item.id ===
                  report['no_answer_agents']['all_data'][filterOption][0].id
              )
          "
        >
          <thead>
            No Answer Agents |
            {{
              report["no_answer_agents"]["all_data"][filterOption][0]
                .total_in_time_frame
            }}
          </thead>
          <tbody>
            <tr>
              <td>
                {{
                  salesPersonList.find(
                    item =>
                      item.id ===
                      report["no_answer_agents"]["all_data"][filterOption][0].id
                  ).full_name
                }}
                |
                {{
                  report["no_answer_agents"]["all_data"][filterOption][0].total
                }}
                |
                {{
                  report["no_answer_agents"]["all_data"][filterOption][0]
                    .total_in_time_frame
                }}
                |
                {{
                  (
                    (100 *
                      report["no_answer_agents"]["all_data"][filterOption][0]
                        .total) /
                    report["no_answer_agents"]["all_data"][filterOption][0]
                      .total_in_time_frame
                  ).toFixed(2)
                }}%
                <br />
                <span
                  class="report-rank"
                  v-for="rank in report['no_answer_agents']['all_data'][
                    filterOption
                  ][0].rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
            <hr />
            <tr>
              <td
                v-for="cond in report['no_answer_agents']['all_data'][
                  filterOption
                ][0].campaign_aaid"
                :key="cond.id"
              >
                <span
                  >{{ cond.id }} | {{ cond.amount }} |
                  {{
                    report["no_answer_agents"]["all_data"][filterOption][0]
                      .total_in_time_frame
                  }}
                  |
                  {{
                    (
                      (100 * cond.amount) /
                      report["no_answer_agents"]["all_data"][filterOption][0]
                        .total_in_time_frame
                    ).toFixed(2)
                  }}% |
                  {{
                    (
                      (100 * cond.amount) /
                      report["no_answer_agents"]["all_data"][filterOption][0]
                        .total
                    ).toFixed(2)
                  }}%</span
                >
                <br />
                <span
                  class="report-rank"
                  v-for="rank in cond.rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
            <tr>
              <td
                v-for="cond in report['no_answer_agents']['all_data'][
                  filterOption
                ][0].country_id"
                :key="cond.id"
              >
                <span
                  >{{
                    dictionaries.general.countries.find(
                      country => country.id === cond.id
                    ).name
                  }}
                  | {{ cond.amount }} |
                  {{
                    report["no_answer_agents"]["all_data"][filterOption][0]
                      .total_in_time_frame
                  }}
                  |
                  {{
                    (
                      (100 * cond.amount) /
                      report["no_answer_agents"]["all_data"][filterOption][0]
                        .total_in_time_frame
                    ).toFixed(2)
                  }}% |
                  {{
                    (
                      (100 * cond.amount) /
                      report["no_answer_agents"]["all_data"][filterOption][0]
                        .total
                    ).toFixed(2)
                  }}%</span
                >
                <br />
                <span
                  class="report-rank"
                  v-for="rank in cond.rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
            <tr>
              <td
                v-for="cond in report['no_answer_agents']['all_data'][
                  filterOption
                ][0].keyword"
                :key="cond.id"
              >
                <span
                  >{{ cond.id }} | {{ cond.amount }} |
                  {{
                    report["no_answer_agents"]["all_data"][filterOption][0]
                      .total_in_time_frame
                  }}
                  |
                  {{
                    (
                      (100 * cond.amount) /
                      report["no_answer_agents"]["all_data"][filterOption][0]
                        .total_in_time_frame
                    ).toFixed(2)
                  }}% |
                  {{
                    (
                      (100 * cond.amount) /
                      report["no_answer_agents"]["all_data"][filterOption][0]
                        .total
                    ).toFixed(2)
                  }}%</span
                >
                <br />
                <span
                  class="report-rank"
                  v-for="rank in cond.rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
        <table
          v-if="
            Object.keys(report).length > 0 &&
              !Array.isArray(
                report['not_interested_leads']['all_data'][filterOption]
              ) &&
              report['not_interested_leads']['all_data'][filterOption]
          "
        >
          <thead>
            Not Interested - Leads |
            {{
              report["not_interested_leads"]["all_data"][filterOption]
                .total_in_time_frame
            }}
          </thead>
          <tbody>
            <tr>
              <td
                v-if="
                  Object.keys(
                    report['not_interested_leads']['all_data'][filterOption]
                      .campaign_aaid
                  ).length > 0
                "
              >
                <span
                  >{{
                    report["not_interested_leads"]["all_data"][filterOption]
                      .campaign_aaid[0].id
                  }}
                  |
                  {{
                    report["not_interested_leads"]["all_data"][filterOption]
                      .campaign_aaid[0].amount
                  }}
                  |
                  {{
                    report["not_interested_leads"]["all_data"][filterOption]
                      .total_in_time_frame
                  }}
                  |
                  {{
                    (
                      (100 *
                        report["not_interested_leads"]["all_data"][filterOption]
                          .campaign_aaid[0].amount) /
                      report["not_interested_leads"]["all_data"][filterOption]
                        .total_in_time_frame
                    ).toFixed(2)
                  }}%</span
                >
                <br />
                <span
                  class="report-rank"
                  v-for="rank in report['not_interested_leads']['all_data'][
                    filterOption
                  ].campaign_aaid[0].rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
            <tr>
              <td
                v-if="
                  Object.keys(
                    report['not_interested_leads']['all_data'][filterOption]
                      .users
                  ).length > 0
                "
              >
                <span>
                  {{
                    salesPersonList.find(
                      item =>
                        item.id ===
                        report["not_interested_leads"]["all_data"][filterOption]
                          .users[0].id
                    ).full_name
                  }}
                  |
                  {{
                    report["not_interested_leads"]["all_data"][filterOption]
                      .users[0].amount
                  }}
                  |
                  {{
                    report["not_interested_leads"]["all_data"][filterOption]
                      .total_in_time_frame
                  }}
                  |
                  {{
                    (
                      (100 *
                        report["not_interested_leads"]["all_data"][filterOption]
                          .users[0].amount) /
                      report["not_interested_leads"]["all_data"][filterOption]
                        .total_in_time_frame
                    ).toFixed(2)
                  }}%
                </span>
                <br />
                <span
                  class="report-rank"
                  v-for="rank in report['not_interested_leads']['all_data'][
                    filterOption
                  ].users[0].rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
            <tr>
              <td
                v-if="
                  Object.keys(
                    report['not_interested_leads']['all_data'][filterOption]
                      .country_id
                  ).length > 0
                "
              >
                <span
                  >{{
                    dictionaries.general.countries.find(
                      country =>
                        country.id ===
                        report["not_interested_leads"]["all_data"][filterOption]
                          .country_id[0].id
                    ).name
                  }}
                  |
                  {{
                    report["not_interested_leads"]["all_data"][filterOption]
                      .country_id[0].amount
                  }}
                  |
                  {{
                    report["not_interested_leads"]["all_data"][filterOption]
                      .total_in_time_frame
                  }}
                  |
                  {{
                    (
                      (100 *
                        report["not_interested_leads"]["all_data"][filterOption]
                          .country_id[0].amount) /
                      report["not_interested_leads"]["all_data"][filterOption]
                        .total_in_time_frame
                    ).toFixed(2)
                  }}%</span
                >
                <br />
                <span
                  class="report-rank"
                  v-for="rank in report['not_interested_leads']['all_data'][
                    filterOption
                  ].country_id[0].rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
            <tr>
              <td
                v-if="
                  Object.keys(
                    report['not_interested_leads']['all_data'][filterOption]
                      .keyword
                  ).length > 0
                "
              >
                <span
                  >{{
                    report["not_interested_leads"]["all_data"][filterOption]
                      .keyword[0].id
                  }}
                  |
                  {{
                    report["not_interested_leads"]["all_data"][filterOption]
                      .keyword[0].amount
                  }}
                  |
                  {{
                    report["not_interested_leads"]["all_data"][filterOption]
                      .total_in_time_frame
                  }}
                  |
                  {{
                    (
                      (100 *
                        report["not_interested_leads"]["all_data"][filterOption]
                          .keyword[0].amount) /
                      report["not_interested_leads"]["all_data"][filterOption]
                        .total_in_time_frame
                    ).toFixed(2)
                  }}%</span
                >
                <br />
                <span
                  class="report-rank"
                  v-for="rank in report['not_interested_leads']['all_data'][
                    filterOption
                  ].keyword[0].rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
        <table
          v-if="
            Object.keys(report).length > 0 &&
              report['not_interested_reasons']['all_data'][filterOption] &&
              report['not_interested_reasons']['all_data'][filterOption]
                .length > 0 &&
              dictionaries.activity.not_int_states.find(
                item =>
                  item.id ===
                  report['not_interested_reasons']['all_data'][filterOption][0]
                    .id
              )
          "
        >
          <thead>
            Not Interested - Reasons |
            {{
              report["not_interested_reasons"]["all_data"][filterOption][0]
                .total_in_time_frame
            }}
          </thead>
          <tbody>
            <tr>
              <td>
                {{
                  dictionaries.activity.not_int_states.find(
                    item =>
                      item.id ===
                      report["not_interested_reasons"]["all_data"][
                        filterOption
                      ][0].id
                  ).name
                }}
                |
                {{
                  report["not_interested_reasons"]["all_data"][filterOption][0]
                    .total
                }}
                |
                {{
                  report["not_interested_reasons"]["all_data"][filterOption][0]
                    .total_in_time_frame
                }}
                |
                {{
                  (
                    (100 *
                      report["not_interested_reasons"]["all_data"][
                        filterOption
                      ][0].total) /
                    report["not_interested_reasons"]["all_data"][
                      filterOption
                    ][0].total_in_time_frame
                  ).toFixed(2)
                }}%
                <br />
                <span
                  class="report-rank"
                  v-for="rank in report['not_interested_reasons']['all_data'][
                    filterOption
                  ][0].rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
            <hr />
            <tr>
              <td
                v-for="cond in report['not_interested_reasons']['all_data'][
                  filterOption
                ][0].users"
                :key="cond.id"
              >
                {{
                  salesPersonList.find(item => item.id === cond.id).full_name
                }}
                | {{ cond.amount }} |
                {{
                  report["not_interested_reasons"]["all_data"][filterOption][0]
                    .total_in_time_frame
                }}
                |
                {{
                  (
                    (100 * cond.amount) /
                    report["not_interested_reasons"]["all_data"][
                      filterOption
                    ][0].total_in_time_frame
                  ).toFixed(2)
                }}% |
                {{
                  (
                    (100 * cond.amount) /
                    report["not_interested_reasons"]["all_data"][
                      filterOption
                    ][0].total
                  ).toFixed(2)
                }}%
                <br />
                <span
                  class="report-rank"
                  v-for="rank in cond.rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
            <tr>
              <td
                v-for="cond in report['not_interested_reasons']['all_data'][
                  filterOption
                ][0].campaign_aaid"
                :key="cond.id"
              >
                <span
                  >{{ cond.id }} | {{ cond.amount }} |
                  {{
                    report["not_interested_reasons"]["all_data"][
                      filterOption
                    ][0].total_in_time_frame
                  }}
                  |
                  {{
                    (
                      (100 * cond.amount) /
                      report["not_interested_reasons"]["all_data"][
                        filterOption
                      ][0].total_in_time_frame
                    ).toFixed(2)
                  }}% |
                  {{
                    (
                      (100 * cond.amount) /
                      report["not_interested_reasons"]["all_data"][
                        filterOption
                      ][0].total
                    ).toFixed(2)
                  }}%</span
                >
                <br />
                <span
                  class="report-rank"
                  v-for="rank in cond.rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
            <tr>
              <td
                v-for="cond in report['not_interested_reasons']['all_data'][
                  filterOption
                ][0].country_id"
                :key="cond.id"
              >
                <span
                  >{{
                    dictionaries.general.countries.find(
                      country => country.id === cond.id
                    ).name
                  }}
                  | {{ cond.amount }} |
                  {{
                    report["not_interested_reasons"]["all_data"][
                      filterOption
                    ][0].total_in_time_frame
                  }}
                  |
                  {{
                    (
                      (100 * cond.amount) /
                      report["not_interested_reasons"]["all_data"][
                        filterOption
                      ][0].total_in_time_frame
                    ).toFixed(2)
                  }}% |
                  {{
                    (
                      (100 * cond.amount) /
                      report["not_interested_reasons"]["all_data"][
                        filterOption
                      ][0].total
                    ).toFixed(2)
                  }}%</span
                >
                <br />
                <span
                  class="report-rank"
                  v-for="rank in cond.rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
            <tr>
              <td
                v-for="cond in report['not_interested_reasons']['all_data'][
                  filterOption
                ][0].keyword"
                :key="cond.id"
              >
                <span
                  >{{ cond.id }} | {{ cond.amount }} |
                  {{
                    report["not_interested_reasons"]["all_data"][
                      filterOption
                    ][0].total_in_time_frame
                  }}
                  |
                  {{
                    (
                      (100 * cond.amount) /
                      report["not_interested_reasons"]["all_data"][
                        filterOption
                      ][0].total_in_time_frame
                    ).toFixed(2)
                  }}% |
                  {{
                    (
                      (100 * cond.amount) /
                      report["not_interested_reasons"]["all_data"][
                        filterOption
                      ][0].total
                    ).toFixed(2)
                  }}%</span
                >
                <br />
                <span
                  class="report-rank"
                  v-for="rank in cond.rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
        <table
          v-if="
            Object.keys(report).length > 0 &&
              !Array.isArray(report['not_reached']['all_data'][filterOption]) &&
              report['not_reached']['all_data'][filterOption]
          "
        >
          <thead>
            Not Reached |
            {{
              report["not_reached"]["all_data"][filterOption]
                .total_in_time_frame
            }}
          </thead>
          <tbody>
            <tr>
              <td
                v-if="
                  Object.keys(
                    report['not_reached']['all_data'][filterOption]
                      .campaign_aaid
                  ).length > 0
                "
              >
                <span
                  >{{
                    report["not_reached"]["all_data"][filterOption]
                      .campaign_aaid[0].id
                  }}
                  |
                  {{
                    report["not_reached"]["all_data"][filterOption]
                      .campaign_aaid[0].amount
                  }}
                  |
                  {{
                    report["not_reached"]["all_data"][filterOption]
                      .total_in_time_frame
                  }}
                  |
                  {{
                    (
                      (100 *
                        report["not_reached"]["all_data"][filterOption]
                          .campaign_aaid[0].amount) /
                      report["not_reached"].total_in_time_frame
                    ).toFixed(2)
                  }}%</span
                >
                <br />
                <span
                  class="report-rank"
                  v-for="rank in report['not_reached']['all_data'][filterOption]
                    .campaign_aaid[0].rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
            <tr>
              <td
                v-if="
                  Object.keys(
                    report['not_reached']['all_data'][filterOption].users
                  ).length > 0
                "
              >
                <span>
                  {{
                    salesPersonList.find(
                      item =>
                        item.id ===
                        report["not_reached"]["all_data"][filterOption].users[0]
                          .id
                    ).full_name
                  }}
                  |
                  {{
                    report["not_reached"]["all_data"][filterOption].users[0]
                      .amount
                  }}
                  |
                  {{
                    report["not_reached"]["all_data"][filterOption]
                      .total_in_time_frame
                  }}
                  |
                  {{
                    (
                      (100 *
                        report["not_reached"]["all_data"][filterOption].users[0]
                          .amount) /
                      report["not_reached"]["all_data"][filterOption]
                        .total_in_time_frame
                    ).toFixed(2)
                  }}%
                </span>
                <br />
                <span
                  class="report-rank"
                  v-for="rank in report['not_reached']['all_data'][filterOption]
                    .users[0].rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
            <tr>
              <td
                v-if="
                  Object.keys(
                    report['not_reached']['all_data'][filterOption].country_id
                  ).length > 0
                "
              >
                <span
                  >{{
                    dictionaries.general.countries.find(
                      country =>
                        country.id ===
                        report["not_reached"]["all_data"][filterOption]
                          .country_id[0].id
                    ).name
                  }}
                  |
                  {{
                    report["not_reached"]["all_data"][filterOption]
                      .country_id[0].amount
                  }}
                  |
                  {{
                    report["not_reached"]["all_data"][filterOption]
                      .total_in_time_frame
                  }}
                  |
                  {{
                    (
                      (100 *
                        report["not_reached"]["all_data"][filterOption]
                          .country_id[0].amount) /
                      report["not_reached"]["all_data"][filterOption]
                        .total_in_time_frame
                    ).toFixed(2)
                  }}%</span
                >
                <br />
                <span
                  class="report-rank"
                  v-for="rank in report['not_reached']['all_data'][filterOption]
                    .country_id[0].rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
            <tr>
              <td
                v-if="
                  Object.keys(
                    report['not_reached']['all_data'][filterOption].keyword
                  ).length > 0
                "
              >
                <span
                  >{{
                    report["not_reached"]["all_data"][filterOption].keyword[0]
                      .id
                  }}
                  |
                  {{
                    report["not_reached"]["all_data"][filterOption].keyword[0]
                      .amount
                  }}
                  |
                  {{
                    report["not_reached"]["all_data"][filterOption]
                      .total_in_time_frame
                  }}
                  |
                  {{
                    (
                      (100 *
                        report["not_reached"]["all_data"][filterOption]
                          .keyword[0].amount) /
                      report["not_reached"]["all_data"][filterOption]
                        .total_in_time_frame
                    ).toFixed(2)
                  }}%</span
                >
                <br />
                <span
                  class="report-rank"
                  v-for="rank in report['not_reached']['all_data'][filterOption]
                    .keyword[0].rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
        <table
          v-if="
            Object.keys(report).length > 0 &&
              !Array.isArray(
                report['registrations']['all_data'][filterOption]
              ) &&
              report['registrations']['all_data'][filterOption]
          "
        >
          <thead>
            Registrations |
            {{
              report["registrations"]["all_data"][filterOption]
                .total_in_time_frame
            }}
          </thead>
          <tbody>
            <tr>
              <td
                v-if="
                  Object.keys(
                    report['registrations']['all_data'][filterOption]
                      .campaign_aaid
                  ).length > 0
                "
              >
                <span
                  >{{
                    report["registrations"]["all_data"][filterOption]
                      .campaign_aaid[0].id
                  }}
                  |
                  {{
                    report["registrations"]["all_data"][filterOption]
                      .campaign_aaid[0].amount
                  }}
                  |
                  {{
                    report["registrations"]["all_data"][filterOption]
                      .total_in_time_frame
                  }}
                  |
                  {{
                    (
                      (100 *
                        report["registrations"]["all_data"][filterOption]
                          .campaign_aaid[0].amount) /
                      report["registrations"]["all_data"][filterOption]
                        .total_in_time_frame
                    ).toFixed(2)
                  }}%</span
                >
                <br />
                <span
                  class="report-rank"
                  v-for="rank in report['registrations']['all_data'][
                    filterOption
                  ].campaign_aaid[0].rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
            <tr>
              <td
                v-if="
                  Object.keys(
                    report['registrations']['all_data'][filterOption].country_id
                  ).length > 0
                "
              >
                <span
                  >{{
                    dictionaries.general.countries.find(
                      country =>
                        country.id ===
                        report["registrations"]["all_data"][filterOption]
                          .country_id[0].id
                    ).name
                  }}
                  |
                  {{
                    report["registrations"]["all_data"][filterOption]
                      .country_id[0].amount
                  }}
                  |
                  {{
                    report["registrations"]["all_data"][filterOption]
                      .total_in_time_frame
                  }}
                  |
                  {{
                    (
                      (100 *
                        report["registrations"]["all_data"][filterOption]
                          .country_id[0].amount) /
                      report["registrations"]["all_data"][filterOption]
                        .total_in_time_frame
                    ).toFixed(2)
                  }}%</span
                >
                <br />
                <span
                  class="report-rank"
                  v-for="rank in report['registrations']['all_data'][
                    filterOption
                  ].country_id[0].rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
            <tr>
              <td
                v-if="
                  Object.keys(
                    report['registrations']['all_data'][filterOption].keyword
                  ).length > 0
                "
              >
                <span
                  >{{
                    report["registrations"]["all_data"][filterOption].keyword[0]
                      .id
                  }}
                  |
                  {{
                    report["registrations"]["all_data"][filterOption].keyword[0]
                      .amount
                  }}
                  |
                  {{
                    report["registrations"]["all_data"][filterOption]
                      .total_in_time_frame
                  }}
                  |
                  {{
                    (
                      (100 *
                        report["registrations"]["all_data"][filterOption]
                          .keyword[0].amount) /
                      report["registrations"]["all_data"][filterOption]
                        .total_in_time_frame
                    ).toFixed(2)
                  }}%</span
                >
                <br />
                <span
                  class="report-rank"
                  v-for="rank in report['registrations']['all_data'][
                    filterOption
                  ].keyword[0].rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
        <table
          v-if="
            Object.keys(report).length > 0 &&
              report['scheduled_call_status']['all_data'][filterOption] &&
              report['scheduled_call_status']['all_data'][filterOption].length >
                0
          "
        >
          <thead>
            Scheduled Calls statuses |
            {{
              report["scheduled_call_status"]["all_data"][filterOption][0]
                .total_in_time_frame
            }}
          </thead>
          <tbody>
            <tr>
              {{
                report["scheduled_call_status"]["all_data"][filterOption][0]
                  .status.type
              }}
              |
              {{
                report["scheduled_call_status"]["all_data"][filterOption][0]
                  .total
              }}
              |
              {{
                report["scheduled_call_status"]["all_data"][filterOption][0]
                  .total_in_time_frame
              }}
              |
              {{
                (
                  (100 *
                    report["scheduled_call_status"]["all_data"][filterOption][0]
                      .total) /
                  report["scheduled_call_status"]["all_data"][filterOption][0]
                    .total_in_time_frame
                ).toFixed(2)
              }}%
              <br />
              <span
                class="report-rank"
                v-for="rank in report['scheduled_call_status']['all_data'][
                  filterOption
                ][0].rankings"
                :key="rank"
                v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
              >
                <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                  {{ rank["id"] }}:{{ rank["rank"] }}|
                </span>
              </span>
            </tr>
            <hr />
            <tr>
              <td
                v-for="cond in report['scheduled_call_status']['all_data'][
                  filterOption
                ][0].campaign_aaid"
                :key="cond.id"
              >
                <span
                  >{{ cond.id }} | {{ cond.amount }} |
                  {{
                    report["scheduled_call_status"]["all_data"][filterOption][0]
                      .total_in_time_frame
                  }}
                  |
                  {{
                    (
                      (100 * cond.amount) /
                      report["scheduled_call_status"]["all_data"][
                        filterOption
                      ][0].total_in_time_frame
                    ).toFixed(2)
                  }}% |
                  {{
                    (
                      (100 * cond.amount) /
                      report["scheduled_call_status"]["all_data"][
                        filterOption
                      ][0].total
                    ).toFixed(2)
                  }}%</span
                >
                <br />
                <span
                  class="report-rank"
                  v-for="rank in cond.rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
            <tr>
              <td
                v-for="cond in report['scheduled_call_status']['all_data'][
                  filterOption
                ][0].country_id"
                :key="cond.id"
              >
                <span
                  >{{
                    dictionaries.general.countries.find(
                      country => country.id === cond.id
                    ).name
                  }}
                  | {{ cond.amount }} |
                  {{
                    report["scheduled_call_status"]["all_data"][filterOption][0]
                      .total_in_time_frame
                  }}
                  |
                  {{
                    (
                      (100 * cond.amount) /
                      report["scheduled_call_status"]["all_data"][
                        filterOption
                      ][0].total_in_time_frame
                    ).toFixed(2)
                  }}% |
                  {{
                    (
                      (100 * cond.amount) /
                      report["scheduled_call_status"]["all_data"][
                        filterOption
                      ][0].total
                    ).toFixed(2)
                  }}%</span
                >
                <br />
                <span
                  class="report-rank"
                  v-for="rank in cond.rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
            <tr>
              <td
                v-for="cond in report['scheduled_call_status']['all_data'][
                  filterOption
                ][0].keyword"
                :key="cond.id"
              >
                <span
                  >{{ cond.id }} | {{ cond.amount }} |
                  {{
                    report["scheduled_call_status"]["all_data"][filterOption][0]
                      .total_in_time_frame
                  }}
                  |
                  {{
                    (
                      (100 * cond.amount) /
                      report["scheduled_call_status"]["all_data"][
                        filterOption
                      ][0].total_in_time_frame
                    ).toFixed(2)
                  }}% |
                  {{
                    (
                      (100 * cond.amount) /
                      report["scheduled_call_status"]["all_data"][
                        filterOption
                      ][0].total
                    ).toFixed(2)
                  }}%</span
                >
                <br />
                <span
                  class="report-rank"
                  v-for="rank in cond.rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
            <tr>
              <td
                v-for="cond in report['scheduled_call_status']['all_data'][
                  filterOption
                ][0].users"
                :key="cond.id"
              >
                {{
                  salesPersonList.find(item => item.id === cond.id).full_name
                }}
                | {{ cond.amount }} |
                {{
                  report["scheduled_call_status"]["all_data"][filterOption][0]
                    .total_in_time_frame
                }}
                |
                {{
                  (
                    (100 * cond.amount) /
                    report["scheduled_call_status"]["all_data"][filterOption][0]
                      .total_in_time_frame
                  ).toFixed(2)
                }}% |
                {{
                  (
                    (100 * cond.amount) /
                    report["scheduled_call_status"]["all_data"][filterOption][0]
                      .total
                  ).toFixed(2)
                }}%
                <br />
                <span
                  class="report-rank"
                  v-for="rank in cond.rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
        <table
          v-if="
            Object.keys(report).length > 0 &&
              report['scheduled_call_auto_status']['all_data'][filterOption] &&
              report['scheduled_call_auto_status']['all_data'][filterOption]
                .length > 0
          "
        >
          <thead>
            Scheduled Calls statuses - Auto |
            {{
              report["scheduled_call_auto_status"]["all_data"][filterOption][0]
                .total_in_time_frame
            }}
          </thead>
          <tbody>
            <tr>
              {{
                report["scheduled_call_auto_status"]["all_data"][
                  filterOption
                ][0].status.type
              }}
              |
              {{
                report["scheduled_call_auto_status"]["all_data"][
                  filterOption
                ][0].total
              }}
              |
              {{
                report["scheduled_call_auto_status"]["all_data"][
                  filterOption
                ][0].total_in_time_frame
              }}
              |
              {{
                (
                  (100 *
                    report["scheduled_call_auto_status"]["all_data"][
                      filterOption
                    ][0].total) /
                  report["scheduled_call_auto_status"]["all_data"][
                    filterOption
                  ][0].total_in_time_frame
                ).toFixed(2)
              }}%
              <br />
              <span
                class="report-rank"
                v-for="rank in report['scheduled_call_auto_status'][
                  filterOption
                ][0].rankings"
                :key="rank"
                v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
              >
                <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                  {{ rank["id"] }}:{{ rank["rank"] }}|
                </span>
              </span>
            </tr>
            <hr />
            <tr>
              <td
                v-for="cond in report['scheduled_call_auto_status'][
                  filterOption
                ][0].campaign_aaid"
                :key="cond.id"
              >
                <span
                  >{{ cond.id }} | {{ cond.amount }} |
                  {{
                    report["scheduled_call_auto_status"]["all_data"][
                      filterOption
                    ][0].total_in_time_frame
                  }}
                  |
                  {{
                    (
                      (100 * cond.amount) /
                      report["scheduled_call_auto_status"]["all_data"][
                        filterOption
                      ][0].total_in_time_frame
                    ).toFixed(2)
                  }}% |
                  {{
                    (
                      (100 * cond.amount) /
                      report["scheduled_call_auto_status"]["all_data"][
                        filterOption
                      ][0].total
                    ).toFixed(2)
                  }}%</span
                >
                <br />
                <span
                  class="report-rank"
                  v-for="rank in cond.rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
            <tr>
              <td
                v-for="cond in report['scheduled_call_auto_status'][
                  filterOption
                ][0].country_id"
                :key="cond.id"
              >
                <span
                  >{{
                    dictionaries.general.countries.find(
                      country => country.id === cond.id
                    ).name
                  }}
                  | {{ cond.amount }} |
                  {{
                    report["scheduled_call_auto_status"]["all_data"][
                      filterOption
                    ][0].total_in_time_frame
                  }}
                  |
                  {{
                    (
                      (100 * cond.amount) /
                      report["scheduled_call_auto_status"]["all_data"][
                        filterOption
                      ][0].total_in_time_frame
                    ).toFixed(2)
                  }}% |
                  {{
                    (
                      (100 * cond.amount) /
                      report["scheduled_call_auto_status"]["all_data"][
                        filterOption
                      ][0].total
                    ).toFixed(2)
                  }}%</span
                >
                <br />
                <span
                  class="report-rank"
                  v-for="rank in cond.rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
            <tr>
              <td
                v-for="cond in report['scheduled_call_auto_status'][
                  filterOption
                ][0].keyword"
                :key="cond.id"
              >
                <span
                  >{{ cond.id }} | {{ cond.amount }} |
                  {{
                    report["scheduled_call_auto_status"]["all_data"][
                      filterOption
                    ][0].total_in_time_frame
                  }}
                  |
                  {{
                    (
                      (100 * cond.amount) /
                      report["scheduled_call_auto_status"]["all_data"][
                        filterOption
                      ][0].total_in_time_frame
                    ).toFixed(2)
                  }}% |
                  {{
                    (
                      (100 * cond.amount) /
                      report["scheduled_call_auto_status"]["all_data"][
                        filterOption
                      ][0].total
                    ).toFixed(2)
                  }}%</span
                >
                <br />
                <span
                  class="report-rank"
                  v-for="rank in cond.rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
            <tr>
              <td
                v-for="cond in report['scheduled_call_auto_status'][
                  filterOption
                ][0].users"
                :key="cond.id"
              >
                {{
                  salesPersonList.find(item => item.id === cond.id).full_name
                }}
                | {{ cond.amount }} |
                {{
                  report["scheduled_call_auto_status"]["all_data"][
                    filterOption
                  ][0].total_in_time_frame
                }}
                |
                {{
                  (
                    (100 * cond.amount) /
                    report["scheduled_call_auto_status"]["all_data"][
                      filterOption
                    ][0].total_in_time_frame
                  ).toFixed(2)
                }}% |
                {{
                  (
                    (100 * cond.amount) /
                    report["scheduled_call_auto_status"]["all_data"][
                      filterOption
                    ][0].total
                  ).toFixed(2)
                }}%
                <br />
                <span
                  class="report-rank"
                  v-for="rank in cond.rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
        <table
          v-if="
            Object.keys(report).length > 0 &&
              report['second_voice']['all_data'][filterOption] &&
              report['second_voice']['all_data'][filterOption].length > 0 &&
              salesPersonList.find(
                item =>
                  item.id ===
                  report['second_voice']['all_data'][filterOption][0].id
              )
          "
        >
          <thead>
            Second Voice |
            {{
              report["second_voice"]["all_data"][filterOption][0]
                .total_in_time_frame
            }}
          </thead>
          <tbody>
            <tr>
              <td>
                {{
                  salesPersonList.find(
                    item =>
                      item.id ===
                      report["second_voice"]["all_data"][filterOption][0].id
                  ).full_name
                }}
                |
                {{ report["second_voice"]["all_data"][filterOption][0].total }}
                |
                {{
                  report["second_voice"]["all_data"][filterOption][0]
                    .total_in_time_frame
                }}
                |
                {{
                  (
                    (100 *
                      report["second_voice"]["all_data"][filterOption][0]
                        .total) /
                    report["second_voice"]["all_data"][filterOption][0]
                      .total_in_time_frame
                  ).toFixed(2)
                }}%
                <br />
                <span
                  class="report-rank"
                  v-for="rank in report['second_voice']['all_data'][
                    filterOption
                  ][0].rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
            <hr />
            <tr>
              <td
                v-for="cond in report['second_voice']['all_data'][
                  filterOption
                ][0].users"
                :key="cond.id"
              >
                {{
                  salesPersonList.find(item => item.id === cond.id).full_name
                }}
                | {{ cond.amount }} |
                {{
                  report["second_voice"]["all_data"][filterOption][0]
                    .total_in_time_frame
                }}
                |
                {{
                  (
                    (100 * cond.amount) /
                    report["second_voice"]["all_data"][filterOption][0]
                      .total_in_time_frame
                  ).toFixed(2)
                }}% |
                {{
                  (
                    (100 * cond.amount) /
                    report["second_voice"]["all_data"][filterOption][0].total
                  ).toFixed(2)
                }}%
                <br />
                <span
                  class="report-rank"
                  v-for="rank in cond.rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
            <tr>
              <td
                v-for="cond in report['second_voice']['all_data'][
                  filterOption
                ][0].campaign_aaid"
                :key="cond.id"
              >
                <span
                  >{{ cond.id }} | {{ cond.amount }} |
                  {{
                    report["second_voice"]["all_data"][filterOption][0]
                      .total_in_time_frame
                  }}
                  |
                  {{
                    (
                      (100 * cond.amount) /
                      report["second_voice"]["all_data"][filterOption][0]
                        .total_in_time_frame
                    ).toFixed(2)
                  }}% |
                  {{
                    (
                      (100 * cond.amount) /
                      report["second_voice"]["all_data"][filterOption][0].total
                    ).toFixed(2)
                  }}%</span
                >
                <br />
                <span
                  class="report-rank"
                  v-for="rank in cond.rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
            <tr>
              <td
                v-for="cond in report['second_voice']['all_data'][
                  filterOption
                ][0].keyword"
                :key="cond.id"
              >
                <span
                  >{{ cond.id }} | {{ cond.amount }} |
                  {{
                    report["second_voice"]["all_data"][filterOption][0]
                      .total_in_time_frame
                  }}
                  |
                  {{
                    (
                      (100 * cond.amount) /
                      report["second_voice"]["all_data"][filterOption][0]
                        .total_in_time_frame
                    ).toFixed(2)
                  }}% |
                  {{
                    (
                      (100 * cond.amount) /
                      report["second_voice"]["all_data"][filterOption][0].total
                    ).toFixed(2)
                  }}%</span
                >
                <br />
                <span
                  class="report-rank"
                  v-for="rank in cond.rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
            <tr>
              <td
                v-for="cond in report['second_voice']['all_data'][
                  filterOption
                ][0].country_id"
                :key="cond.id"
              >
                <span
                  >{{
                    dictionaries.general.countries.find(
                      country => country.id === cond.id
                    ).name
                  }}
                  | {{ cond.amount }} |
                  {{
                    report["second_voice"]["all_data"][filterOption][0]
                      .total_in_time_frame
                  }}
                  |
                  {{
                    (
                      (100 * cond.amount) /
                      report["second_voice"]["all_data"][filterOption][0]
                        .total_in_time_frame
                    ).toFixed(2)
                  }}% |
                  {{
                    (
                      (100 * cond.amount) /
                      report["second_voice"]["all_data"][filterOption][0].total
                    ).toFixed(2)
                  }}%</span
                >
                <br />
                <span
                  class="report-rank"
                  v-for="rank in cond.rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
        <table
          v-if="
            Object.keys(report).length > 0 &&
              report['transferred_to']['all_data'][filterOption] &&
              report['transferred_to']['all_data'][filterOption].length > 0 &&
              salesPersonList.find(
                item =>
                  item.id ===
                  report['transferred_to']['all_data'][filterOption][0].id
              )
          "
        >
          <thead>
            Transferred to Agents |
            {{
              report["transferred_to"]["all_data"][filterOption][0]
                .total_in_time_frame
            }}
          </thead>
          <tbody>
            <tr>
              <td>
                {{
                  salesPersonList.find(
                    item =>
                      item.id ===
                      report["transferred_to"]["all_data"][filterOption][0].id
                  ).full_name
                }}
                |
                {{
                  report["transferred_to"]["all_data"][filterOption][0].total
                }}
                |
                {{
                  report["transferred_to"]["all_data"][filterOption][0]
                    .total_in_time_frame
                }}
                |
                {{
                  (
                    (100 *
                      report["transferred_to"]["all_data"][filterOption][0]
                        .total) /
                    report["transferred_to"]["all_data"][filterOption][0]
                      .total_in_time_frame
                  ).toFixed(2)
                }}%
                <br />
                <span
                  class="report-rank"
                  v-for="rank in report['transferred_to']['all_data'][
                    filterOption
                  ][0].rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
            <hr />
            <tr>
              <td
                v-for="cond in report['transferred_to']['all_data'][
                  filterOption
                ][0].campaign_aaid"
                :key="cond.id"
              >
                <span
                  >{{ cond.id }} | {{ cond.amount }} |
                  {{
                    report["transferred_to"]["all_data"][filterOption][0]
                      .total_in_time_frame
                  }}
                  |
                  {{
                    (
                      (100 * cond.amount) /
                      report["transferred_to"]["all_data"][filterOption][0]
                        .total_in_time_frame
                    ).toFixed(2)
                  }}% |
                  {{
                    (
                      (100 * cond.amount) /
                      report["transferred_to"]["all_data"][filterOption][0]
                        .total
                    ).toFixed(2)
                  }}%</span
                >
                <br />
                <span
                  class="report-rank"
                  v-for="rank in cond.rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
            <tr>
              <td
                v-for="cond in report['transferred_to']['all_data'][
                  filterOption
                ][0].country_id"
                :key="cond.id"
              >
                <span
                  >{{
                    dictionaries.general.countries.find(
                      country => country.id === cond.id
                    ).name
                  }}
                  | {{ cond.amount }} |
                  {{
                    report["transferred_to"]["all_data"][filterOption][0]
                      .total_in_time_frame
                  }}
                  |
                  {{
                    (
                      (100 * cond.amount) /
                      report["transferred_to"]["all_data"][filterOption][0]
                        .total_in_time_frame
                    ).toFixed(2)
                  }}% |
                  {{
                    (
                      (100 * cond.amount) /
                      report["transferred_to"]["all_data"][filterOption][0]
                        .total
                    ).toFixed(2)
                  }}%</span
                >
                <br />
                <span
                  class="report-rank"
                  v-for="rank in cond.rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
            <tr>
              <td
                v-for="cond in report['transferred_to']['all_data'][
                  filterOption
                ][0].keyword"
                :key="cond.id"
              >
                <span
                  >{{ cond.id }} | {{ cond.amount }} |
                  {{
                    report["transferred_to"]["all_data"][filterOption][0]
                      .total_in_time_frame
                  }}
                  |
                  {{
                    (
                      (100 * cond.amount) /
                      report["transferred_to"]["all_data"][filterOption][0]
                        .total_in_time_frame
                    ).toFixed(2)
                  }}% |
                  {{
                    (
                      (100 * cond.amount) /
                      report["transferred_to"]["all_data"][filterOption][0]
                        .total
                    ).toFixed(2)
                  }}%</span
                >
                <br />
                <span
                  class="report-rank"
                  v-for="rank in cond.rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
        <table
          v-if="
            Object.keys(report).length > 0 &&
              report['transferred_to_live']['all_data'][filterOption] &&
              report['transferred_to_live']['all_data'][filterOption].length >
                0 &&
              salesPersonList.find(
                item =>
                  item.id ===
                  report['transferred_to_live']['all_data'][filterOption][0].id
              )
          "
        >
          <thead>
            Transferred to Agents - Live |
            {{
              report["transferred_to_live"]["all_data"][filterOption][0]
                .total_in_time_frame
            }}
          </thead>
          <tbody>
            <tr>
              <td>
                {{
                  salesPersonList.find(
                    item =>
                      item.id ===
                      report["transferred_to_live"]["all_data"][filterOption][0]
                        .id
                  ).full_name
                }}
                |
                {{
                  report["transferred_to_live"]["all_data"][filterOption][0]
                    .total
                }}
                |
                {{
                  report["transferred_to_live"]["all_data"][filterOption][0]
                    .total_in_time_frame
                }}
                |
                {{
                  (
                    (100 *
                      report["transferred_to_live"]["all_data"][filterOption][0]
                        .total) /
                    report["transferred_to_live"]["all_data"][filterOption][0]
                      .total_in_time_frame
                  ).toFixed(2)
                }}%
                <br />
                <span
                  class="report-rank"
                  v-for="rank in report['transferred_to_live']['all_data'][
                    filterOption
                  ][0].rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
            <hr />
            <tr>
              <td
                v-for="cond in report['transferred_to_live']['all_data'][
                  filterOption
                ][0].campaign_aaid"
                :key="cond.id"
              >
                <span
                  >{{ cond.id }} | {{ cond.amount }} |
                  {{
                    report["transferred_to_live"]["all_data"][filterOption][0]
                      .total_in_time_frame
                  }}
                  |
                  {{
                    (
                      (100 * cond.amount) /
                      report["transferred_to_live"]["all_data"][filterOption][0]
                        .total_in_time_frame
                    ).toFixed(2)
                  }}% |
                  {{
                    (
                      (100 * cond.amount) /
                      report["transferred_to_live"]["all_data"][filterOption][0]
                        .total
                    ).toFixed(2)
                  }}%</span
                >
                <br />
                <span
                  class="report-rank"
                  v-for="rank in cond.rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
            <tr>
              <td
                v-for="cond in report['transferred_to_live']['all_data'][
                  filterOption
                ][0].country_id"
                :key="cond.id"
              >
                <span
                  >{{
                    dictionaries.general.countries.find(
                      country => country.id === cond.id
                    ).name
                  }}
                  | {{ cond.amount }} |
                  {{
                    report["transferred_to_live"]["all_data"][filterOption][0]
                      .total_in_time_frame
                  }}
                  |
                  {{
                    (
                      (100 * cond.amount) /
                      report["transferred_to_live"]["all_data"][filterOption][0]
                        .total_in_time_frame
                    ).toFixed(2)
                  }}% |
                  {{
                    (
                      (100 * cond.amount) /
                      report["transferred_to_live"]["all_data"][filterOption][0]
                        .total
                    ).toFixed(2)
                  }}%</span
                >
                <br />
                <span
                  class="report-rank"
                  v-for="rank in cond.rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
            <tr>
              <td
                v-for="cond in report['transferred_to_live']['all_data'][
                  filterOption
                ][0].keyword"
                :key="cond.id"
              >
                <span
                  >{{ cond.id }} | {{ cond.amount }} |
                  {{
                    report["transferred_to_live"]["all_data"][filterOption][0]
                      .total_in_time_frame
                  }}
                  |
                  {{
                    (
                      (100 * cond.amount) /
                      report["transferred_to_live"]["all_data"][filterOption][0]
                        .total_in_time_frame
                    ).toFixed(2)
                  }}% |
                  {{
                    (
                      (100 * cond.amount) /
                      report["transferred_to_live"]["all_data"][filterOption][0]
                        .total
                    ).toFixed(2)
                  }}%</span
                >
                <br />
                <span
                  class="report-rank"
                  v-for="rank in cond.rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
        <table
          v-if="
            Object.keys(report).length > 0 &&
              report['transferred_to_online']['all_data'][filterOption] &&
              report['transferred_to_online']['all_data'][filterOption].length >
                0 &&
              salesPersonList.find(
                item =>
                  item.id ===
                  report['transferred_to_online']['all_data'][filterOption][0]
                    .id
              )
          "
        >
          <thead>
            Transferred to Agents - Online |
            {{
              report["transferred_to_online"]["all_data"][filterOption][0]
                .total_in_time_frame
            }}
          </thead>
          <tbody>
            <tr>
              <td>
                {{
                  salesPersonList.find(
                    item =>
                      item.id ===
                      report["transferred_to_online"]["all_data"][
                        filterOption
                      ][0].id
                  ).full_name
                }}
                |
                {{
                  report["transferred_to_online"]["all_data"][filterOption][0]
                    .total
                }}
                |
                {{
                  report["transferred_to_online"]["all_data"][filterOption][0]
                    .total_in_time_frame
                }}
                |
                {{
                  (
                    (100 *
                      report["transferred_to_online"]["all_data"][
                        filterOption
                      ][0].total) /
                    report["transferred_to_online"]["all_data"][filterOption][0]
                      .total_in_time_frame
                  ).toFixed(2)
                }}%
                <br />
                <span
                  class="report-rank"
                  v-for="rank in report['transferred_to_online'][
                    filterOption
                  ][0].rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
            <hr />
            <tr>
              <td
                v-for="cond in report['transferred_to_online']['all_data'][
                  filterOption
                ][0].campaign_aaid"
                :key="cond.id"
              >
                <span
                  >{{ cond.id }} | {{ cond.amount }} |
                  {{
                    report["transferred_to_online"]["all_data"][filterOption][0]
                      .total_in_time_frame
                  }}
                  |
                  {{
                    (
                      (100 * cond.amount) /
                      report["transferred_to_online"]["all_data"][
                        filterOption
                      ][0].total_in_time_frame
                    ).toFixed(2)
                  }}% |
                  {{
                    (
                      (100 * cond.amount) /
                      report["transferred_to_online"]["all_data"][
                        filterOption
                      ][0].total
                    ).toFixed(2)
                  }}%</span
                >
                <br />
                <span
                  class="report-rank"
                  v-for="rank in cond.rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
            <tr>
              <td
                v-for="cond in report['transferred_to_online']['all_data'][
                  filterOption
                ][0].country_id"
                :key="cond.id"
              >
                <span
                  >{{
                    dictionaries.general.countries.find(
                      country => country.id === cond.id
                    ).name
                  }}
                  | {{ cond.amount }} |
                  {{
                    report["transferred_to_online"]["all_data"][filterOption][0]
                      .total_in_time_frame
                  }}
                  |
                  {{
                    (
                      (100 * cond.amount) /
                      report["transferred_to_online"]["all_data"][
                        filterOption
                      ][0].total_in_time_frame
                    ).toFixed(2)
                  }}% |
                  {{
                    (
                      (100 * cond.amount) /
                      report["transferred_to_online"]["all_data"][
                        filterOption
                      ][0].total
                    ).toFixed(2)
                  }}%</span
                >
                <br />
                <span
                  class="report-rank"
                  v-for="rank in cond.rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
            <tr>
              <td
                v-for="cond in report['transferred_to_online']['all_data'][
                  filterOption
                ][0].keyword"
                :key="cond.id"
              >
                <span
                  >{{ cond.id }} | {{ cond.amount }} |
                  {{
                    report["transferred_to_online"]["all_data"][filterOption][0]
                      .total_in_time_frame
                  }}
                  |
                  {{
                    (
                      (100 * cond.amount) /
                      report["transferred_to_online"]["all_data"][
                        filterOption
                      ][0].total_in_time_frame
                    ).toFixed(2)
                  }}% |
                  {{
                    (
                      (100 * cond.amount) /
                      report["transferred_to_online"]["all_data"][
                        filterOption
                      ][0].total
                    ).toFixed(2)
                  }}%</span
                >
                <br />
                <span
                  class="report-rank"
                  v-for="rank in cond.rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
        <table
          v-if="
            Object.keys(report).length > 0 &&
              !Array.isArray(
                report['cc_decline_deposits']['all_data'][filterOption]
              ) &&
              report['cc_decline_deposits']['all_data'][filterOption]
          "
        >
          <thead>
            CC - Decline deposits |
            {{
              report["cc_decline_deposits"]["all_data"][filterOption]
                .total_clients_in_time_frame
            }}
            |
            {{
              report["cc_decline_deposits"]["all_data"][filterOption]
                .total_deposits_in_time_frame
            }}
          </thead>
          <tbody>
            <tr>
              <td
                v-if="
                  Object.keys(
                    report['cc_decline_deposits']['all_data'][filterOption]
                      .campaign_aaid
                  ).length > 0
                "
              >
                <span
                  >{{
                    report["cc_decline_deposits"]["all_data"][filterOption]
                      .campaign_aaid[0].id
                  }}
                  |
                  {{
                    report["cc_decline_deposits"]["all_data"][filterOption]
                      .campaign_aaid[0].amount
                  }}
                  |
                  {{
                    report["cc_decline_deposits"]["all_data"][filterOption]
                      .total_clients_in_time_frame
                  }}
                  |
                  {{
                    report["cc_decline_deposits"]["all_data"][filterOption]
                      .campaign_aaid[0].deposits
                  }}
                  |
                  {{
                    report["cc_decline_deposits"]["all_data"][filterOption]
                      .total_deposits_in_time_frame
                  }}
                  |
                  {{
                    (
                      (100 *
                        report["cc_decline_deposits"]["all_data"][filterOption]
                          .campaign_aaid[0].amount) /
                      report["cc_decline_deposits"]["all_data"][filterOption]
                        .total_clients_in_time_frame
                    ).toFixed(2)
                  }}%</span
                >
                <br />
                <span
                  class="report-rank"
                  v-for="rank in report['cc_decline_deposits']['all_data'][
                    filterOption
                  ].campaign_aaid[0].rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
            <tr>
              <td
                v-if="
                  Object.keys(
                    report['cc_decline_deposits']['all_data'][filterOption]
                      .users
                  ).length > 0
                "
              >
                <span>
                  {{
                    salesPersonList.find(
                      item =>
                        item.id ===
                        report["cc_decline_deposits"]["all_data"][filterOption]
                          .users[0].id
                    ).full_name
                  }}
                  |
                  {{
                    report["cc_decline_deposits"]["all_data"][filterOption]
                      .users[0].amount
                  }}
                  |
                  {{
                    report["cc_decline_deposits"]["all_data"][filterOption]
                      .total_clients_in_time_frame
                  }}
                  |
                  {{
                    report["cc_decline_deposits"]["all_data"][filterOption]
                      .users[0].deposits
                  }}
                  |
                  {{
                    report["cc_decline_deposits"]["all_data"][filterOption]
                      .total_deposits_in_time_frame
                  }}
                  |
                  {{
                    (
                      (100 *
                        report["cc_decline_deposits"]["all_data"][filterOption]
                          .users[0].amount) /
                      report["cc_decline_deposits"]["all_data"][filterOption]
                        .total_clients_in_time_frame
                    ).toFixed(2)
                  }}%
                </span>
                <br />
                <span
                  class="report-rank"
                  v-for="rank in report['cc_decline_deposits']['all_data'][
                    filterOption
                  ].users[0].rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
            <tr>
              <td
                v-if="
                  Object.keys(
                    report['cc_decline_deposits']['all_data'][filterOption]
                      .country_id
                  ).length > 0
                "
              >
                <span
                  >{{
                    dictionaries.general.countries.find(
                      country =>
                        country.id ===
                        report["cc_decline_deposits"]["all_data"][filterOption]
                          .country_id[0].id
                    ).name
                  }}
                  |
                  {{
                    report["cc_decline_deposits"]["all_data"][filterOption]
                      .country_id[0].amount
                  }}
                  |
                  {{
                    report["cc_decline_deposits"]["all_data"][filterOption]
                      .total_clients_in_time_frame
                  }}
                  |
                  {{
                    report["cc_decline_deposits"]["all_data"][filterOption]
                      .country_id[0].deposits
                  }}
                  |
                  {{
                    report["cc_decline_deposits"]["all_data"][filterOption]
                      .total_deposits_in_time_frame
                  }}
                  |
                  {{
                    (
                      (100 *
                        report["cc_decline_deposits"]["all_data"][filterOption]
                          .country_id[0].amount) /
                      report["cc_decline_deposits"]["all_data"][filterOption]
                        .total_clients_in_time_frame
                    ).toFixed(2)
                  }}%</span
                >
                <br />
                <span
                  class="report-rank"
                  v-for="rank in report['cc_decline_deposits']['all_data'][
                    filterOption
                  ].country_id[0].rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
            <tr>
              <td
                v-if="
                  Object.keys(
                    report['cc_decline_deposits']['all_data'][filterOption]
                      .keyword
                  ).length > 0
                "
              >
                <span
                  >{{
                    report["cc_decline_deposits"]["all_data"][filterOption]
                      .keyword[0].id
                  }}
                  |
                  {{
                    report["cc_decline_deposits"]["all_data"][filterOption]
                      .keyword[0].amount
                  }}
                  |
                  {{
                    report["cc_decline_deposits"]["all_data"][filterOption]
                      .total_clients_in_time_frame
                  }}
                  |
                  {{
                    report["cc_decline_deposits"]["all_data"][filterOption]
                      .keyword[0].deposits
                  }}
                  |
                  {{
                    report["cc_decline_deposits"]["all_data"][filterOption]
                      .total_deposits_in_time_frame
                  }}
                  |
                  {{
                    (
                      (100 *
                        report["cc_decline_deposits"]["all_data"][filterOption]
                          .keyword[0].amount) /
                      report["cc_decline_deposits"]["all_data"][filterOption]
                        .total_clients_in_time_frame
                    ).toFixed(2)
                  }}%</span
                >
                <br />
                <span
                  class="report-rank"
                  v-for="rank in report['cc_decline_deposits']['all_data'][
                    filterOption
                  ].keyword[0].rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
        <!--        <table-->
        <!--          v-if="-->
        <!--            Object.keys(report).length > 0 &&-->
        <!--              report['assigned_agents_conversion'] &&-->
        <!--              report['assigned_agents_conversion'].length > 0-->
        <!--          "-->
        <!--        >-->
        <!--          <thead>-->
        <!--            Assigned Agents - Conversion |-->
        <!--            {{-->
        <!--              report["assigned_agents_conversion"][0].total_in_time_frame-->
        <!--            }}-->
        <!--          </thead>-->
        <!--          <tbody>-->
        <!--            <tr>-->
        <!--              <td>-->
        <!--                {{-->
        <!--                  salesPersonList.find(-->
        <!--                    item =>-->
        <!--                      item.id ===-->
        <!--                      report["assigned_agents_conversion"][0].id-->
        <!--                  ).full_name-->
        <!--                }}-->
        <!--                | {{ report["assigned_agents_conversion"][0].conversion }}%-->
        <!--                | {{ report["assigned_agents_conversion"][0].total }} |-->
        <!--                {{-->
        <!--                  report["assigned_agents_conversion"][0].total_in_time_frame-->
        <!--                }}-->
        <!--                |-->
        <!--                {{-->
        <!--                  (-->
        <!--                    (100 * report["assigned_agents_conversion"][0].total) /-->
        <!--                    report["assigned_agents_conversion"][0].total_in_time_frame-->
        <!--                  ).toFixed(2)-->
        <!--                }}%-->
        <!--              </td>-->
        <!--            </tr>-->
        <!--            <hr />-->
        <!--            <tr>-->
        <!--              <td-->
        <!--                v-for="cond in report['assigned_agents_conversion'][0]-->
        <!--                  .campaign_aaid"-->
        <!--                :key="cond.id"-->
        <!--              >-->
        <!--                <span-->
        <!--                  >{{ cond.id }} | {{ cond.amount }} |-->
        <!--                  {{-->
        <!--                    report["assigned_agents_conversion"][0].total_in_time_frame-->
        <!--                  }}-->
        <!--                  |-->
        <!--                  {{-->
        <!--                    (-->
        <!--                      (100 * cond.amount) /-->
        <!--                      report["assigned_agents_conversion"][0]-->
        <!--                        .total_in_time_frame-->
        <!--                    ).toFixed(2)-->
        <!--                  }}% |-->
        <!--                  {{-->
        <!--                    (-->
        <!--                      (100 * cond.amount) /-->
        <!--                      report["assigned_agents_conversion"][0].total-->
        <!--                    ).toFixed(2)-->
        <!--                  }}%</span-->
        <!--                >-->
        <!--              </td>-->
        <!--            </tr>-->
        <!--            <tr>-->
        <!--              <td-->
        <!--                v-for="cond in report['assigned_agents_conversion'][0]-->
        <!--                  .country_id"-->
        <!--                :key="cond.id"-->
        <!--              >-->
        <!--                <span-->
        <!--                  >{{-->
        <!--                    dictionaries.general.countries.find(-->
        <!--                      country => country.id === cond.id-->
        <!--                    ).name-->
        <!--                  }}-->
        <!--                  | {{ cond.amount }} |-->
        <!--                  {{-->
        <!--                    report["assigned_agents_conversion"][0].total_in_time_frame-->
        <!--                  }}-->
        <!--                  |-->
        <!--                  {{-->
        <!--                    (-->
        <!--                      (100 * cond.amount) /-->
        <!--                      report["assigned_agents_conversion"][0]-->
        <!--                        .total_in_time_frame-->
        <!--                    ).toFixed(2)-->
        <!--                  }}% |-->
        <!--                  {{-->
        <!--                    (-->
        <!--                      (100 * cond.amount) /-->
        <!--                      report["assigned_agents_conversion"][0].total-->
        <!--                    ).toFixed(2)-->
        <!--                  }}%</span-->
        <!--                >-->
        <!--              </td>-->
        <!--            </tr>-->
        <!--            <tr>-->
        <!--              <td-->
        <!--                v-for="cond in report['assigned_agents_conversion'][0].keyword"-->
        <!--                :key="cond.id"-->
        <!--              >-->
        <!--                <span-->
        <!--                  >{{ cond.id }} | {{ cond.amount }} |-->
        <!--                  {{-->
        <!--                    report["assigned_agents_conversion"][0].total_in_time_frame-->
        <!--                  }}-->
        <!--                  |-->
        <!--                  {{-->
        <!--                    (-->
        <!--                      (100 * cond.amount) /-->
        <!--                      report["assigned_agents_conversion"][0]-->
        <!--                        .total_in_time_frame-->
        <!--                    ).toFixed(2)-->
        <!--                  }}% |-->
        <!--                  {{-->
        <!--                    (-->
        <!--                      (100 * cond.amount) /-->
        <!--                      report["assigned_agents_conversion"][0].total-->
        <!--                    ).toFixed(2)-->
        <!--                  }}%</span-->
        <!--                >-->
        <!--              </td>-->
        <!--            </tr>-->
        <!--          </tbody>-->
        <!--        </table>-->

        <!--        <table-->
        <!--          v-if="-->
        <!--            Object.keys(report).length > 0 &&-->
        <!--              !Array.isArray(report['pro_club']) &&-->
        <!--              report['pro_club']-->
        <!--          "-->
        <!--        >-->
        <!--          <thead>-->
        <!--            Pro Club |-->
        <!--            {{-->
        <!--              report["pro_club"].total_clients_in_time_frame-->
        <!--            }}-->
        <!--            |-->
        <!--            {{-->
        <!--              report["pro_club"].total_deposits_in_time_frame-->
        <!--            }}-->
        <!--          </thead>-->
        <!--          <tbody>-->
        <!--            <tr>-->
        <!--              <td-->
        <!--                v-if="Object.keys(report['pro_club'].campaign_aaid).length > 0"-->
        <!--              >-->
        <!--                <span-->
        <!--                  >{{ report["pro_club"].campaign_aaid[0].id }} |-->
        <!--                  {{ report["pro_club"].campaign_aaid[0].amount }} |-->
        <!--                  {{ report["pro_club"].total_clients_in_time_frame }} |-->
        <!--                  {{ report["pro_club"].campaign_aaid[0].deposits }} |-->
        <!--                  {{ report["pro_club"].total_deposits_in_time_frame }} |-->
        <!--                  {{-->
        <!--                    (-->
        <!--                      (100 * report["pro_club"].campaign_aaid[0].amount) /-->
        <!--                      report["pro_club"].total_clients_in_time_frame-->
        <!--                    ).toFixed(2)-->
        <!--                  }}%</span-->
        <!--                >-->
        <!--              </td>-->
        <!--            </tr>-->
        <!--            <tr>-->
        <!--              <td v-if="Object.keys(report['pro_club'].users).length > 0">-->
        <!--                <span>-->
        <!--                  {{-->
        <!--                    salesPersonList.find(-->
        <!--                      item => item.id === report["pro_club"].users[0].id-->
        <!--                    ).full_name-->
        <!--                  }}-->
        <!--                  | {{ report["pro_club"].users[0].amount }} |-->
        <!--                  {{ report["pro_club"].total_clients_in_time_frame }} |-->
        <!--                  {{ report["pro_club"].users[0].deposits }} |-->
        <!--                  {{ report["pro_club"].total_deposits_in_time_frame }} |-->
        <!--                  {{-->
        <!--                    (-->
        <!--                      (100 * report["pro_club"].users[0].amount) /-->
        <!--                      report["pro_club"].total_clients_in_time_frame-->
        <!--                    ).toFixed(2)-->
        <!--                  }}%-->
        <!--                </span>-->
        <!--              </td>-->
        <!--            </tr>-->
        <!--            <tr>-->
        <!--              <td v-if="Object.keys(report['pro_club'].country_id).length > 0">-->
        <!--                <span-->
        <!--                  >{{-->
        <!--                    dictionaries.general.countries.find(-->
        <!--                      country =>-->
        <!--                        country.id === report["pro_club"].country_id[0].id-->
        <!--                    ).name-->
        <!--                  }}-->
        <!--                  | {{ report["pro_club"].country_id[0].amount }} |-->
        <!--                  {{ report["pro_club"].total_clients_in_time_frame }} |-->
        <!--                  {{ report["pro_club"].country_id[0].deposits }} |-->
        <!--                  {{ report["pro_club"].total_deposits_in_time_frame }} |-->
        <!--                  {{-->
        <!--                    (-->
        <!--                      (100 * report["pro_club"].country_id[0].amount) /-->
        <!--                      report["pro_club"].total_clients_in_time_frame-->
        <!--                    ).toFixed(2)-->
        <!--                  }}%</span-->
        <!--                >-->
        <!--              </td>-->
        <!--            </tr>-->
        <!--            <tr>-->
        <!--              <td v-if="Object.keys(report['pro_club'].keyword).length > 0">-->
        <!--                <span-->
        <!--                  >{{ report["pro_club"].keyword[0].id }} |-->
        <!--                  {{ report["pro_club"].keyword[0].amount }} |-->
        <!--                  {{ report["pro_club"].total_clients_in_time_frame }} |-->
        <!--                  {{ report["pro_club"].keyword[0].deposits }} |-->
        <!--                  {{ report["pro_club"].total_deposits_in_time_frame }} |-->
        <!--                  {{-->
        <!--                    (-->
        <!--                      (100 * report["pro_club"].keyword[0].amount) /-->
        <!--                      report["pro_club"].total_clients_in_time_frame-->
        <!--                    ).toFixed(2)-->
        <!--                  }}%</span-->
        <!--                >-->
        <!--              </td>-->
        <!--            </tr>-->
        <!--          </tbody>-->
        <!--        </table>-->
      </div>

      <loader class="loader" :size="'8px'" v-if="reportBusy"></loader>
    </div>
    <div class="bottom-div" v-if="false">
      <span v-if="false"
        >Forbidden, You are not authorized to see this data</span
      >

      <loader :size="'11px'" v-if="reportBusy"></loader>

      <div class="fab"><span class="fas fa-file-csv"></span></div>
    </div>
  </div>
</template>

<script>
import Loader from "../../../../../main/misc.main/loader/Loader";
import {mapGetters, mapState} from "vuex";
import apiClientCreator from "../../../../../helpers/api/request";
import DatePicker from "vue2-datepicker";
import moment from "moment";
export default {
  name: "DailyReport.container",
  components: { Loader, DatePicker },
  data() {
    return {
      reportBusy: false,
      report: [],
      rawData: {
        0: [],
        1: [],
        30: [],
        90: []
      },
      reportDate: null,
      filterOption: "ALL"
    };
  },
  computed: {
    ...mapState("user", ["auth"]),
    ...mapState("clients", ["dictionaries", "salesPersonList"])
  },
  created() {
    this.getTimelyReport(1);
  },
  methods: {
    async getTimelyReport(timeFrame) {
      if (
        !this.reportBusy &&
        this.checkPermissions(this.auth, [1, 2, 3, 4, 12])
      ) {
        try {
          this.reportBusy = true;
          const res = await apiClientCreator(
            `reports/timely_report/${timeFrame}`
          ).get("");
          this.report = res.data["report"];
          this.reportBusy = false;
        } catch (e) {}
      }
    },
    checkPermissions(user, permitted) {
      return permitted.some(role => role === user.user.role);
    },
    changeFilter(event) {
      this.filterOption = event.target.value;
    },
    async getReportByDate() {
      if (
        !this.reportBusy &&
        this.checkPermissions(this.auth, [1, 2, 3, 4, 12])
      ) {
        try {
          this.reportBusy = true;
          const res = await apiClientCreator(
            `reports/timely_report_by_date/1/${moment(this.reportDate).format(
              "YYYY-MM-DD"
            )}`
          ).get("");
          this.report = res.data;
          this.reportBusy = false;
        } catch (e) {}
      }
    }
  }
};
</script>

<style scoped>
.body-div {
  padding: 4px 5px 1px 5px;
}
.top-div {
  height: 650px;
  overflow-y: scroll;
  margin: auto;
  background: white;
  border-radius: 3px;
  padding: 5px;
}
.bottom-div {
  width: 100%;
  height: 650px;
  overflow-y: scroll;
  margin: 5px auto;
  background: white;
  border-radius: 3px;
  padding: 5px;
  position: relative;
}
.fab {
  background-color: transparent;
  padding: 0;
  font-size: 30px;
  line-height: 30px;
  color: green;
  text-align: center;
  position: absolute;
  right: 10px;
  bottom: 10px;
  border-radius: 20%;
  transition: all 0.1s ease-in-out;
  cursor: pointer;
}

.fab:hover {
  box-shadow: 0 5px 11px 0 #666;
  transform: scale(1.05);
}
.table {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
}
.table td {
  padding: 0.3em 0;
}
.table table {
  font-size: 13px;
  width: 1500px;
  margin: 3em 0;
}
.table thead {
  border-bottom: solid 2px #eff3f6;
}
.table tfoot {
  border-top: solid 2px #eff3f6;
  color: red;
}
.table th {
  text-align: center;
}
.text-center {
  font-weight: bold;
}
.loader {
  left: 0;
  right: 0;
}
.negative {
  color: red;
}
.positive {
  color: green;
}
.filter-buttons {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: white;
}
input {
  margin: 0.4em;
}
.filter-group {
  padding-right: 6em;
}
.bttn {
  width: 100%;
  margin-top: 0.5rem;
  background: #44a2d2;
  color: white;
  border: 0;
  border-radius: inherit;
  padding: 5px;
  font-size: 12px;
  font-family: inherit;
  cursor: pointer;
}
.disabled {
  background-color: #cccccc;
  color: #666666;
  cursor: not-allowed;
}
.report-wrapper {
  display: flex;
  flex-direction: column;
}
</style>
